'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _validator = require('validator');

var filterValue = function filterValue(value) {
	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    trim = _ref.trim,
	    exclude = _ref.exclude,
	    include = _ref.include,
	    max = _ref.max,
	    limitOnMax = _ref.limitOnMax,
	    filter = _ref.filter;

	if (value === undefined || value === null) {
		return value;
	}

	var filteredValue = String(value);

	if (trim) {
		filteredValue = (0, _validator.trim)(value);
	}

	if (exclude) {
		filteredValue = (0, _validator.blacklist)(filteredValue, exclude);
	}

	if (include) {
		filteredValue = (0, _validator.whitelist)(filteredValue, include);
	}

	if (filter) {
		filteredValue = filter(filteredValue);
	}

	// IMPORTANT: This needs to be last in case a previous filter shortens the length
	if (limitOnMax && Number.isInteger(max)) {
		filteredValue = filteredValue.slice(0, max);
	}

	return filteredValue;
};

exports.default = filterValue;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMValidatingTextField/filter.js